module.exports = __webpack_public_path__ + "images/emoji/ferris_wheel.1f8ac59056ac00e1f0d8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ferris_wheel.png
// module id = 37R3
// module chunks = 2